export const SITE_URL = "https://www.1902enterprises.com";

export const SITE_NAME = "1902 Enterprises";

export const SITE_TAGLINE = "Marketing & Growth Partner";

export const SITE_TITLE = `${SITE_NAME} | ${SITE_TAGLINE}`;

export const SITE_DESCRIPTION =
  "1902 Enterprises is a premium marketing and growth partner specializing in sponsorships, partnerships, video production, digital marketing, and performance strategy for brands ready to scale.";

export const SITE_KEYWORDS = [
  "1902 Enterprises",
  "marketing agency",
  "growth partner",
  "sponsorships",
  "partnerships",
  "video production",
  "digital marketing",
  "performance marketing",
  "brand strategy",
  "creative agency",
  "Chennai marketing agency",
  "India marketing agency",
].join(", ");

export const SITE_LOCALE = "en_IN";

export const SITE_CONTACT_EMAIL = "hello@1902enterprises.com";

export const SITE_SOCIAL = {
  linkedin: "https://www.linkedin.com/company/1902-enterprises",
  instagram: "https://www.instagram.com/1902enterprises",
};

export const SITE_OG_IMAGE = `${SITE_URL}/images/og-banner.jpg`;
export const SITE_OG_IMAGE_WIDTH = 1200;
export const SITE_OG_IMAGE_HEIGHT = 630;
export const SITE_OG_IMAGE_ALT =
  "1902 Enterprises — Sponsorships. Stories. Cinematic growth.";

export const SITE_LOGO = `${SITE_URL}/images/logo.png`;

export const SITE_FOUNDED = "2023";

export const SITE_ADDRESS = {
  addressLocality: "Chennai",
  addressRegion: "Tamil Nadu",
  addressCountry: "IN",
};

export const SITE_SERVICES = [
  "Partnerships & Sponsorships",
  "Video Production & Creative",
  "Marketing Strategy & Growth",
  "Digital Marketing & Performance",
  "Account & Operations",
  "Technology & Development",
];
